import { SpriteSheetLoader } from "@/components/loader/sprite-sheet-loader";

interface LoaderProps {
	small?: boolean;
	message?: string;
}

const Loader = ({ small = false, message }: LoaderProps) => {
	return (
		<div
			className={`d-flex justify-content-center align-items-center h-100 w-100 ${small ? "h-100" : "py-5 vh-100"}`}
		>
			<SpriteSheetLoader 
				size={small ? "small" : "large"} 
				message={message}
				speed={0.8}
			/>
		</div>
	);
};

export { Loader };
